import React, { useState, useRef, useEffect } from "react";
import "./Products.css";
import { IoAddCircleSharp } from "react-icons/io5";
import { BsFolderPlus } from "react-icons/bs";
import { MdDeleteForever } from "react-icons/md";
import axios from "axios";

function Products({ products, fetchprod }) {
  const [pvproduct, setpvproduct] = useState({
    category: "",
    brand: "",
    prod_name: "",
    prod_desc: "",
    prod_size: "",
    features: "",
    Key_value: "",
    delivery_time: "",
    status: "",
    return: false,
    return_policy: "",
    payment: [],
  });

  const [newProduct, setNewProduct] = useState({
    category: "",
    brand: "",
    prod_name: "",
    prod_desc: "",
    features: "",
    Keywords: "",
    delivery_time: "",
    status: "active",
  });

  const [returnDays, setReturnDays] = useState("");

  const [Addmore, setAddmore] = useState(false);

  const [hasReturn, setHasReturn] = useState(false);
  // const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  // payment
  const paymentOptions = [
    "Credit/Debit Card",
    "Net Banking",
    "UPI",
    "Wallets (Paytm Google Pay etc.)",
    "Cash on Delivery",
    "EMI",
  ];

  const [selectedPayments, setSelectedPayments] = useState([]);

  const toggleSelection = (option) => {
    setSelectedPayments((prev) =>
      prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, option]
    );
  };

  const [sizeData, setSizeData] = useState({});
  const [prevProduct, setPrevProduct] = useState(null);

  const sizeOptions = ["S", "M", "L", "XL", "XXL", "Free Size"];

  useEffect(() => {
    if (!prevProduct) return;
    const {
      prod_size = [],
      prod_price = [],
      prod_discount = [],
      discounted_amount = [],
      stock = [],
    } = prevProduct;

    const structured = {};
    prod_size.forEach((size, i) => {
      structured[size] = {
        enabled: true,
        price: prod_price[i] || "",
        discount: prod_discount[i] || "",
        net: discounted_amount[i] || "",
        stock: stock[i] || "",
      };
    });

    setSizeData(structured);
  }, [prevProduct]);

  const updateSizeData = (size, field, value) => {
    const price =
      field === "price" ? parseFloat(value) : parseFloat(sizeData[size].price);
    const discount =
      field === "discount"
        ? parseFloat(value)
        : parseFloat(sizeData[size].discount);

    const net =
      price && discount ? (price - price * (discount / 100)).toFixed(2) : "";

    setSizeData((prev) => ({
      ...prev,
      [size]: {
        ...prev[size],
        [field]: value,
        net,
      },
    }));
  };

  const isVideoFile = (filename) => {
    const videoExts = ["mp4", "webm", "ogg"];
    const ext = filename.split(".").pop().toLowerCase();
    return videoExts.includes(ext);
  };

  const deleteImageFromServer = async (url) => {
    const filename = url.split("/").pop();
    const formData = new FormData();
    formData.append("filename", filename);
    formData.append("product_id", prevProduct?.product_id);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/prod_img_delete.php`,
        formData
      );

      if (res.data?.success) {
        console.log("Image deleted:", filename);
        fetchprod();
      } else {
        console.warn(
          "Server responded but did not confirm deletion:",
          res.data
        );
      }
    } catch (error) {
      console.error("Failed to delete image:", error);
    }
  };

  const handleRemoveMainPreview = (indexToRemove) => {
    const totalMedia = mediaUrls.length;

    if (indexToRemove < totalMedia) {
      const fileToDelete = mediaUrls[indexToRemove];
      deleteImageFromServer(fileToDelete);

      const updated = mediaUrls.filter((_, i) => i !== indexToRemove);
      setMediaUrls(updated);

      const totalRemaining = updated.length + previews.length;
      if (totalRemaining === 0) {
        setMainPreviewIndex(null);
      } else {
        setMainPreviewIndex(
          indexToRemove >= totalRemaining ? totalRemaining - 1 : indexToRemove
        );
      }
    } else {
      const previewIndex = indexToRemove - totalMedia;
      const updated = previews.filter((_, i) => i !== previewIndex);
      setPreviews(updated);

      const totalRemaining = mediaUrls.length + updated.length;
      if (totalRemaining === 0) {
        setMainPreviewIndex(null);
      } else {
        setMainPreviewIndex(
          indexToRemove >= totalRemaining ? totalRemaining - 1 : indexToRemove
        );
      }
    }
  };

  const [filesToUpload, setFilesToUpload] = useState([]);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const newPreviews = files.map((file) => URL.createObjectURL(file));

    setPreviews((prev) => [...prev, ...newPreviews]);
    setFilesToUpload((prev) => [...prev, ...files]);

    if (mainPreviewIndex === null && newPreviews.length > 0) {
      setMainPreviewIndex(mediaUrls.length); // starts from after existing
    }
  };

  const handleThumbnailClick = (index) => {
    setMainPreviewIndex(index);
  };

  const productdel = async (id) => {
    const formData = new FormData();
    formData.append("product_id", id);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/prod_delete.php`,
        formData
      );

      if (res.data?.success) {
        await fetchprod();

        console.log("Product deleted Successful");
      } else {
        console.warn(
          "Server responded but did not confirm deletion:",
          res.data
        );
      }
    } catch (error) {
      console.error("Failed to delete image:", error);
    }
  };

  const updateprod = async (id) => {
    const formData = new FormData();

    formData.append("product_id", id);
    formData.append("category", pvproduct.category || prevProduct.category);
    formData.append("brand", pvproduct.brand || prevProduct.brand);
    formData.append("prod_name", pvproduct.prod_name || prevProduct.prod_name);
    formData.append("prod_desc", pvproduct.prod_desc || prevProduct.prod_desc);
    formData.append("prod_size", pvproduct.prod_size || prevProduct.prod_size);
    formData.append(
      "prod_price",
      (pvproduct.prod_price || prevProduct.prod_price)?.join(",")
    );
    formData.append(
      "prod_discount",
      (pvproduct.prod_discount || prevProduct.prod_discount)?.join(",")
    );
    formData.append(
      "discounted_amount",
      (pvproduct.discounted_amount || prevProduct.discounted_amount)?.join(",")
    );
    formData.append("stock", (pvproduct.stock || prevProduct.stock)?.join(","));
    formData.append("features", pvproduct.features || prevProduct.features);
    formData.append("key_value", pvproduct.Keywords || prevProduct.key_value);
    formData.append(
      "delivery_time",
      pvproduct.delivery_time || prevProduct.delivery_time
    );

    if (pvproduct.return) {
      formData.append("return_policy", pvproduct.returnDays || "0");
    } else {
      formData.append("return_policy", "no return");
    }

    formData.append("status", pvproduct.status || prevProduct.status);
    formData.append(
      "payment",
      (pvproduct.payment || prevProduct.payment)?.join(",")
    );

    const existingNames = mediaUrls
      .filter((url) => typeof url === "string" && url.length > 0)
      .map((url) => url.split("/").pop());

    if (filesToUpload && filesToUpload.length > 0) {
      filesToUpload.forEach((file) => {
        formData.append("image_string[]", file);
      });
    }

    if (existingNames.length > 0) {
      formData.append("existing_images", existingNames.join(","));
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/prod_update.php`,
        formData
      );

      if (
        res.data?.success ||
        (res.data?.message &&
          res.data.message.toLowerCase().includes("success"))
      ) {
        await fetchprod();
        setIsEditable(false);
        setUpdatedId(id);
        setpvproduct({});
        setPreviews([]);
        setMainPreviewIndex(null);
        setFilesToUpload([]);
        console.log("✅ Product updated successfully");
      } else if (res.data?.message === "No data changed") {
        setIsEditable(false);
        console.log("✅ No changes on product");
      } else {
        console.warn("⚠️ Update not confirmed:", res.data);
      }
    } catch (error) {
      console.error("❌ Failed to update product:", error);
    }
  };

  const [mediaUrls, setMediaUrls] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [mainPreviewIndex, setMainPreviewIndex] = useState(null);
  const [isEditable, setIsEditable] = useState(false);
  const fileInputRef = useRef(null);
  const [updatedId, setUpdatedId] = useState(null);

  useEffect(() => {
    if (prevProduct?.prod_img) {
      const files = prevProduct.prod_img
        .split(",")
        .map((file) => file.trim())
        .filter((f) => f);
      const urls = files.map(
        (file) =>
          `${process.env.REACT_APP_BASEURL}/apis/vendor/uploads/products/${file}`
      );
      setMediaUrls(urls);
      setMainPreviewIndex(0);
    }
  }, [prevProduct]);

  const allPreviews = [...mediaUrls, ...previews];

  useEffect(() => {
    if (prevProduct) {
      setpvproduct((prev) => ({
        ...prev,
        category: prevProduct.category || "",
        brand: prevProduct.brand || "",
        prod_name: prevProduct.prod_name || "",
        prod_desc: prevProduct.prod_desc || "",
        features: prevProduct.features || "",
        Key_value: prevProduct.key_value || "",
        delivery_time: prevProduct.delivery_time || "",
        status: prevProduct.status || "",
        return: prevProduct.return === 1, // boolean from DB
        return_policy: prevProduct.return_policy || "",
        payment: Array.isArray(prevProduct.payment)
          ? prevProduct.payment.map((p) => p.trim())
          : [],
      }));
    }
  }, [prevProduct]);

  useEffect(() => {
    if (updatedId && products.length > 0) {
      const refreshedProduct = products.find((p) => p.product_id === updatedId);
      if (refreshedProduct) {
        setPrevProduct(refreshedProduct);
        setUpdatedId(null);
      }
    }
  }, [updatedId, products]);

  const addProduct = async () => {
    const formData = new FormData();

    const enabledSizes = Object.entries(sizeData).filter(
      ([_, val]) => val.enabled
    );
    const sizes = enabledSizes.map(([key]) => key);
    const prices = enabledSizes.map(([_, val]) => val.price);
    const discounts = enabledSizes.map(([_, val]) => val.discount);
    const nets = enabledSizes.map(([_, val]) => val.net);
    const stocks = enabledSizes.map(([_, val]) => val.stock);

    formData.append("vendor_id", "1");
    formData.append("category", newProduct.category || "");
    formData.append("brand", newProduct.brand || "");
    formData.append("prod_name", newProduct.prod_name || "");
    formData.append("prod_desc", newProduct.prod_desc || "");
    formData.append("prod_size[]", sizes.join(","));
    formData.append("prod_price", prices.join(","));
    formData.append("prod_discount", discounts.join(","));
    formData.append("discounted_amount", nets.join(","));
    formData.append("stock[]", stocks.join(","));
    formData.append("features", newProduct.features || "");
    formData.append("key_value", newProduct.Keywords || "");
    formData.append("deliver_time", newProduct.delivery_time || "");
    formData.append(
      "return_policy",
      hasReturn ? returnDays || "0" : "no return"
    );
    formData.append("status", newProduct.status || "inactive");
    formData.append("payment", selectedPayments.join(","));

    if (filesToUpload && filesToUpload.length > 0) {
      filesToUpload.forEach((file) => {
        formData.append("image_string[]", file);
      });
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/prod_add.php`,
        formData
      );
      if (
        res.data?.success ||
        res.data?.message?.toLowerCase().includes("success")
      ) {
        await fetchprod();
        setNewProduct({
          category: "",
          brand: "",
          prod_name: "",
          prod_desc: "",
          features: "",
          Keywords: "",
          delivery_time: "",
          status: "active",
        });
        setFilesToUpload([]);
        setPreviews([]);
        setMainPreviewIndex(null);
        setSelectedPayments([]);
        setHasReturn(false);
        setReturnDays("");
        setAddmore(false);
        const resetSizeData = {};
        sizeOptions.forEach((size) => {
          resetSizeData[size] = {
            enabled: false,
            price: "",
            discount: "",
            net: "",
            stock: "",
          };
        });
        setSizeData(resetSizeData);
        console.log("✅ Product added successfully");
      } else if (
        res?.data?.message === "At least one product image is required"
      ) {
        alert("Select atleast one image to Upload");
      } else {
        console.warn("⚠️ Add not confirmed:", res.data);
      }
    } catch (error) {
      console.error("❌ Failed to add product:", error);
    }
  };
  const handleRemoveMainsPreview = () => {
    if (mainPreviewIndex !== null) {
      const newPreviews = [...previews];
      newPreviews.splice(mainPreviewIndex, 1);
      setPreviews(newPreviews);
      setFilesToUpload((prev) => {
        const newFiles = [...prev];
        newFiles.splice(mainPreviewIndex, 1);
        return newFiles;
      });

      // Reset index if list is now empty or index was last item
      if (newPreviews.length === 0 || mainPreviewIndex >= newPreviews.length) {
        setMainPreviewIndex(null);
      } else {
        setMainPreviewIndex(0);
      }
    }
  };

  // useEffect(() => {
  //   if(isEditable){
  //     fetchprod();
  //   }
  // }, [isEditable])

  const canceledit = () => {
    if (isEditable) {
      fetchprod();
      setFilesToUpload([]);

      setPrevProduct(null);
      setIsEditable(false);
    } else {
      setIsEditable(false);
      setPrevProduct(null);
    }
  };

  return (
    <div>
      <h1 className="dashboard-heading">Our Products</h1>

      <div
        className="products-summary-cards"
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          margin: "30px",
        }}
      >
        <div className="summary-card total">
          <div className="summary-title">Total Products</div>
          <div className="summary-value">{products.length}</div>
        </div>
        <div className="summary-card active">
          <div className="summary-title">Active</div>
          <div className="summary-value">
            {products.filter((item) => item.status === "active").length}
          </div>
        </div>
        <div className="summary-card inactive">
          <div className="summary-title">Inactive</div>
          <div className="summary-value">
            {products.filter((item) => item.status === "inactive").length}
          </div>
        </div>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {Array.isArray(products) && products.length > 0
          ? products.map((item, index) => (
              <div
                key={index}
                className="card-wrapper"
                onClick={() => setPrevProduct(item)}
              >
                <div className="card-box">
                  {item.status === "inactive" ? (
                    <div>
                      <div className="card-badge inactive">inactive</div>
                    </div>
                  ) : null}
                  <div
                    className="delete"
                    title="Delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      productdel(item.product_id);
                    }}
                  >
                    {" "}
                    <MdDeleteForever />
                  </div>
                  <div className="card-image-wrapper">
                    <img
                      src={`${
                        process.env.REACT_APP_BASEURL
                      }/apis/vendor/uploads/products/${item.prod_img?.split(",")[0]}`}
                      alt={item.prod_name}
                      className="card-img"
                    />
                  </div>

                  <div className="card-info">
                    <div className="card-title">{item.product_id}</div>
                    <span className="card-subtitle">{item.prod_name}</span>
                  </div>
                </div>
              </div>
            ))
          : null}

        <div className="card-wrapper">
          <div className="card-box add" onClick={() => setAddmore(true)}>
            <div className="add-more-icon">
              <IoAddCircleSharp />
            </div>
            <h3>Add More</h3>
          </div>
        </div>
      </div>

      {prevProduct && (
        <>
          <div className="modal-overlay" onClick={canceledit} />
          {/* {showCancelConfirm && (
            <div className="confirm-overlay">
              <div className="confirm-box">
                <p>
                  The product is in edit mode. Are you sure you want to cancel?
                </p>
                <button
                  onClick={() => {
                    setShowCancelConfirm(false);
                    setPrevProduct(null);
                    setIsEditable(false);
                  }}
                >
                  Yes, Cancel
                </button>
                <button onClick={() => setShowCancelConfirm(false)}>
                  No, Stay
                </button>
              </div>
            </div>
          )} */}

          <div
            className="add-more-modal large"
            onClick={(e) => e.stopPropagation()}
          >
            <h2>{prevProduct?.product_id}</h2>
            <div className="table-header">
              <button
                className="edit-btn"
                onClick={() => setIsEditable((prev) => !prev)}
              >
                {isEditable ? (
                  <span>
                    <span style={{ marginRight: 5 }}>❌</span>Cancel
                  </span>
                ) : (
                  <span>
                    <span style={{ marginRight: 5 }}>✏️</span>Edit
                  </span>
                )}
              </button>
            </div>
            <div>
              {/* first set  */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "30px",
                }}
              >
                {/* LEFT SIDE: IMAGE UPLOAD */}

                <div>
                  <div className="upload-box">
                    {allPreviews.length > 0 &&
                    mainPreviewIndex !== null &&
                    allPreviews[mainPreviewIndex] ? (
                      <div className="main-preview-wrapper">
                        {isVideoFile(allPreviews[mainPreviewIndex]) ? (
                          <video
                            src={allPreviews[mainPreviewIndex]}
                            className="main-preview-image"
                            controls
                          />
                        ) : (
                          <img
                            src={allPreviews[mainPreviewIndex]}
                            alt="Main preview"
                            className="main-preview-image"
                          />
                        )}

                        {isEditable && (
                          <div className="preview-controls">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveMainPreview(mainPreviewIndex);
                              }}
                            >
                              Remove
                            </button>
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>

                  {/* Thumbnails */}
                  <div className="preview-list">
                    {allPreviews.map((src, i) => (
                      <div
                        key={i}
                        className="preview-thumb"
                        onClick={() => setMainPreviewIndex(i)}
                        title="Click to set as main image"
                        style={{ cursor: "pointer" }}
                      >
                        {isVideoFile(src) ? (
                          <video
                            src={src}
                            muted
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <img
                            src={src}
                            alt={`preview-${i}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </div>
                    ))}

                    {isEditable && (
                      <div
                        className="preview-thumb"
                        onClick={() => fileInputRef.current?.click()}
                        title="Click to add new image"
                        style={{
                          border: "2px dashed #aaa",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "24px",
                          color: "#999",
                          cursor: "pointer",
                        }}
                      >
                        <BsFolderPlus className="upload-icon" size={28} />
                      </div>
                    )}

                    <input
                      type="file"
                      accept="image/*,video/*"
                      multiple
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </div>
                </div>

                {/* RIGHT SIDE: PRODUCT INFO */}
                <div style={{ width: "100%", maxWidth: "600px" }}>
                  <div className="row">
                    <div>
                      <label className="field-title">Category</label>
                      {isEditable ? (
                        <select
                          value={pvproduct.category}
                          onChange={(e) =>
                            setpvproduct((prev) => ({
                              ...prev,
                              category: e.target.value,
                            }))
                          }
                        >
                          <option value="" disabled>
                            Select Category
                          </option>
                          <option value="electronics">Electronics</option>
                          <option value="fashion">Fashion</option>
                          <option value="grocery">Grocery</option>
                          <option value="home">Home</option>
                        </select>
                      ) : (
                        <input
                          type="text"
                          value={prevProduct?.category || ""}
                          readOnly
                        />
                      )}
                    </div>

                    <div>
                      <label className="field-title">Brand</label>
                      <input
                        type="text"
                        value={
                          isEditable
                            ? pvproduct.brand
                            : prevProduct?.brand || ""
                        }
                        onChange={(e) => {
                          if (isEditable) {
                            setpvproduct((prev) => ({
                              ...prev,
                              brand: e.target.value,
                            }));
                          }
                        }}
                        readOnly={!isEditable}
                      />
                    </div>
                  </div>

                  <label className="field-title">Product Name</label>
                  <input
                    type="text"
                    value={
                      isEditable
                        ? pvproduct.prod_name
                        : prevProduct?.prod_name || ""
                    }
                    onChange={(e) => {
                      if (isEditable) {
                        setpvproduct((prev) => ({
                          ...prev,
                          prod_name: e.target.value,
                        }));
                      }
                    }}
                    readOnly={!isEditable}
                  />

                  <label className="field-title">Description</label>
                  <textarea
                    className="textarea"
                    value={
                      isEditable
                        ? pvproduct.prod_desc
                        : prevProduct?.prod_desc || ""
                    }
                    onChange={(e) => {
                      if (isEditable) {
                        setpvproduct((prev) => ({
                          ...prev,
                          prod_desc: e.target.value,
                        }));
                      }
                    }}
                    readOnly={!isEditable}
                  />

                  <label className="field-title">Features</label>
                  <textarea
                    className="textarea"
                    value={
                      isEditable
                        ? pvproduct.features
                        : prevProduct?.features || ""
                    }
                    onChange={(e) => {
                      if (isEditable) {
                        setpvproduct((prev) => ({
                          ...prev,
                          features: e.target.value,
                        }));
                      }
                    }}
                    readOnly={!isEditable}
                  />

                  <div>
                    <label className="field-title">Keywords / Hashtags</label>
                    <textarea
                      className="textarea"
                      value={
                        isEditable
                          ? pvproduct.key_value
                          : prevProduct?.key_value || ""
                      }
                      onChange={(e) => {
                        if (isEditable) {
                          setpvproduct((prev) => ({
                            ...prev,
                            Key_value: e.target.value,
                          }));
                        }
                      }}
                      readOnly={!isEditable}
                    />
                  </div>
                </div>
              </div>

              {/* size table  */}
              <div className="size-pricing-table">
                <h3 className="field-title">Size Pricing</h3>

                <table className="size-table">
                  <thead>
                    <tr>
                      <th>Enable</th>
                      <th>Size</th>
                      <th>Price</th>
                      <th>Discount %</th>
                      <th>Net Price</th>
                      <th>Stock</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(sizeData).map((size) => (
                      <tr key={size}>
                        <td>
                          <input
                            type="checkbox"
                            checked={sizeData[size].enabled}
                            disabled={!isEditable}
                            onChange={(e) =>
                              setSizeData((prev) => ({
                                ...prev,
                                [size]: {
                                  ...prev[size],
                                  enabled: e.target.checked,
                                },
                              }))
                            }
                          />
                        </td>
                        <td>{size}</td>
                        <td>
                          <input
                            type="number"
                            placeholder="Price"
                            disabled={!isEditable || !sizeData[size].enabled}
                            value={sizeData[size].price}
                            onChange={(e) =>
                              updateSizeData(size, "price", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            max={100}
                            min={0}
                            placeholder="Discount %"
                            disabled={!isEditable || !sizeData[size].enabled}
                            value={sizeData[size].discount}
                            onChange={(e) =>
                              updateSizeData(size, "discount", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            readOnly
                            value={sizeData[size].net}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            min={0}
                            placeholder="Stock"
                            disabled={!isEditable || !sizeData[size].enabled}
                            value={sizeData[size].stock}
                            onChange={(e) =>
                              updateSizeData(size, "stock", e.target.value)
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* 2nd set  */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "30px",
                }}
              >
                <div style={{ width: "100%", maxWidth: "600px" }}>
                  {/* Payment Methods */}
                  <div className="payment-methods">
                    <h3 className="field-title">Accepted Payment Methods</h3>
                    <div className="payment-grid">
                      {paymentOptions.map((option, index) => (
                        <label
                          key={index}
                          className={`payment-card ${
                            pvproduct.payment?.includes(option)
                              ? "selected"
                              : ""
                          }`}
                        >
                          <input
                            type="checkbox"
                            value={option}
                            checked={pvproduct.payment?.includes(option)}
                            onChange={() => {
                              if (!isEditable) return;

                              const updated = pvproduct.payment?.includes(
                                option
                              )
                                ? pvproduct.payment.filter((p) => p !== option)
                                : [...(pvproduct.payment || []), option];

                              setpvproduct((prev) => ({
                                ...prev,
                                payment: updated,
                              }));
                            }}
                          />
                          {option}
                          {pvproduct.payment?.includes(option) && (
                            <span className="checkmark">✔</span>
                          )}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Return Policy */}
                  <label className="field-title">Return Policy</label>
                  <div className="return-policy-toggle">
                    <input
                      className="return-checkbox"
                      type="checkbox"
                      id="returnCheckbox"
                      checked={pvproduct.return}
                      disabled={!isEditable}
                      onChange={(e) =>
                        setpvproduct((prev) => ({
                          ...prev,
                          return: e.target.checked,
                        }))
                      }
                    />
                    <label
                      htmlFor="returnCheckbox"
                      style={{ textWrap: "nowrap", paddingRight: "20px" }}
                    >
                      Enable Returns
                    </label>

                    {pvproduct.return && (
                      <input
                        type="number"
                        min={1}
                        max={30}
                        value={pvproduct.returnDays}
                        disabled={!isEditable}
                        onChange={(e) =>
                          setpvproduct((prev) => ({
                            ...prev,
                            returnDays: e.target.value,
                          }))
                        }
                        placeholder="Return Policy Days"
                        className="return-days-input"
                      />
                    )}
                  </div>
                </div>

                <div style={{ width: "100%", maxWidth: "600px" }}>
                  {/* Delivery Time */}
                  <label className="field-title">Delivery Time (in Days)</label>
                  <input
                    type="text"
                    value={
                      isEditable
                        ? pvproduct.delivery_time
                        : prevProduct?.delivery_time || ""
                    }
                    onChange={(e) => {
                      if (isEditable) {
                        setpvproduct((prev) => ({
                          ...prev,
                          delivery_time: e.target.value,
                        }));
                      }
                    }}
                    readOnly={!isEditable}
                  />

                  {/* Product Status */}
                  <label className="field-title">Product Status</label>
                  {isEditable ? (
                    <select
                      value={pvproduct.status}
                      onChange={(e) =>
                        setpvproduct((prev) => ({
                          ...prev,
                          status: e.target.value,
                        }))
                      }
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  ) : (
                    <input
                      type="text"
                      readOnly
                      value={prevProduct?.status || ""}
                    />
                  )}
                </div>
              </div>

              {isEditable && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => updateprod(prevProduct?.product_id)}
                    style={{ maxWidth: "fit-content" }}
                  >
                    Update the Product
                  </button>
                </div>
              )}
            </div>

            {/* Add content for previous products here */}
          </div>
        </>
      )}

      {Addmore && (
        <>
          <div className="modal-overlay" onClick={() => setAddmore(false)} />
          <div className="add-more-modal large">
            <h2>Add New Product</h2>
            <form>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "30px",
                }}
              >
                {/* LEFT: Image Upload */}
                <div>
                  <div
                    className="upload-box"
                    title="Click to upload image"
                    onClick={() => fileInputRef.current.click()}
                  >
                    {mainPreviewIndex !== null && previews[mainPreviewIndex] ? (
                      <div className="main-preview-wrapper">
                        <img
                          src={previews[mainPreviewIndex]}
                          alt="Selected preview"
                          className="main-preview-image"
                        />
                        <div className="preview-controls">
                          <button onClick={handleRemoveMainsPreview}>
                            Remove
                          </button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <BsFolderPlus className="upload-icon" />
                        <p>Click to upload image</p>
                      </>
                    )}
                  </div>

                  <input
                    type="file"
                    accept="image/*,video/*"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    multiple
                  />

                  {previews.length > 0 && (
                    <div className="preview-list">
                      {previews.map((src, i) => (
                        <div
                          key={i}
                          className="preview-thumb"
                          onClick={() => handleThumbnailClick(i)}
                          title="Click to set as main image"
                          style={{ cursor: "pointer" }}
                        >
                          <img src={src} alt={`preview-${i}`} />
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* RIGHT: Product Info */}
                <div style={{ width: "100%", maxWidth: "600px" }}>
                  <div className="row">
                    <div>
                      <label className="field-title">Category</label>
                      <select
                        value={newProduct.category || ""}
                        onChange={(e) =>
                          setNewProduct((prev) => ({
                            ...prev,
                            category: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select Category</option>
                        <option value="electronics">Electronics</option>
                        <option value="fashion">Fashion</option>
                        <option value="grocery">Grocery</option>
                        <option value="home">Home</option>
                      </select>
                    </div>
                    <div>
                      <label className="field-title">Brand</label>
                      <input
                        type="text"
                        placeholder="Brand"
                        value={newProduct.brand || ""}
                        onChange={(e) =>
                          setNewProduct((prev) => ({
                            ...prev,
                            brand: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  <label className="field-title">Product Name</label>
                  <input
                    type="text"
                    placeholder="Product Name"
                    value={newProduct.prod_name || ""}
                    onChange={(e) =>
                      setNewProduct((prev) => ({
                        ...prev,
                        prod_name: e.target.value,
                      }))
                    }
                    required
                  />

                  <label className="field-title">Product Description</label>
                  <textarea
                    className="textarea"
                    placeholder="Product Description"
                    value={newProduct.prod_desc || ""}
                    onChange={(e) =>
                      setNewProduct((prev) => ({
                        ...prev,
                        prod_desc: e.target.value,
                      }))
                    }
                    required
                  />

                  <label className="field-title">Product Features</label>
                  <textarea
                    className="textarea"
                    placeholder="Features"
                    value={newProduct.features || ""}
                    onChange={(e) =>
                      setNewProduct((prev) => ({
                        ...prev,
                        features: e.target.value,
                      }))
                    }
                  />

                  <label className="field-title">Keywords / Hashtags</label>
                  <textarea
                    className="textarea"
                    placeholder="Keywords like #summer #fashion"
                    value={newProduct.Keywords || ""}
                    onChange={(e) =>
                      setNewProduct((prev) => ({
                        ...prev,
                        Keywords: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>

              {/* Size Pricing Table */}
              <div className="size-pricing-table">
                <h3 className="field-title">Price</h3>
                <table>
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Size</th>
                      <th>Total Price</th>
                      <th>Discount (%)</th>
                      <th>Net Price</th>
                      <th>Stock</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sizeOptions.map((size) => {
                      const current = sizeData[size] || {};
                      const isEnabled = current.enabled || false;

                      return (
                        <tr key={size}>
                          <td>
                            <input
                              type="checkbox"
                              checked={isEnabled}
                              onChange={(e) =>
                                setSizeData((prev) => ({
                                  ...prev,
                                  [size]: {
                                    ...(prev[size] || {}),
                                    enabled: e.target.checked,
                                  },
                                }))
                              }
                            />
                          </td>
                          <td>{size}</td>
                          <td>
                            <input
                              type="number"
                              placeholder="Price"
                              disabled={!isEnabled}
                              value={current.price || ""}
                              onChange={(e) =>
                                updateSizeData(size, "price", e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              max={100}
                              min={1}
                              placeholder="Discount %"
                              disabled={!isEnabled}
                              value={current.discount || ""}
                              onChange={(e) =>
                                updateSizeData(size, "discount", e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              readOnly
                              value={current.net || ""}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              placeholder="Stock"
                              min={2}
                              disabled={!isEnabled}
                              value={current.stock || ""}
                              onChange={(e) =>
                                updateSizeData(size, "stock", e.target.value)
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Second Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "30px",
                }}
              >
                <div style={{ width: "100%", maxWidth: "600px" }}>
                  <h3 className="field-title">Accepted Payment Methods</h3>
                  <div className="payment-grid">
                    {paymentOptions.map((option, index) => (
                      <label
                        key={index}
                        className={`payment-card ${
                          selectedPayments.includes(option) ? "selected" : ""
                        }`}
                        onClick={() => toggleSelection(option)}
                      >
                        <input
                          type="checkbox"
                          checked={selectedPayments.includes(option)}
                          onChange={() => toggleSelection(option)}
                        />
                        {option}
                        {selectedPayments.includes(option) && (
                          <span className="checkmark">✔</span>
                        )}
                      </label>
                    ))}
                  </div>

                  <label className="field-title">Return Policy</label>
                  <div className="return-policy-toggle">
                    <input
                      className="return-checkbox"
                      type="checkbox"
                      checked={hasReturn}
                      onChange={(e) => setHasReturn(e.target.checked)}
                    />
                    <label style={{ textWrap: "nowrap", paddingRight: "20px" }}>
                      Enable Returns
                    </label>
                    {hasReturn && (
                      <input
                        type="number"
                        min={1}
                        max={30}
                        value={returnDays}
                        onChange={(e) => setReturnDays(e.target.value)}
                        placeholder="Return Policy Days"
                        className="return-days-input"
                      />
                    )}
                  </div>
                </div>

                <div style={{ width: "100%", maxWidth: "600px" }}>
                  <label className="field-title">Delivery Time (in Days)</label>
                  <input
                    type="number"
                    max={20}
                    min={1}
                    placeholder="e.g. 3, 5"
                    value={newProduct.delivery_time || ""}
                    onChange={(e) =>
                      setNewProduct((prev) => ({
                        ...prev,
                        delivery_time: e.target.value,
                      }))
                    }
                  />

                  <label className="field-title">Product Status</label>
                  <select
                    value={newProduct.status || "active"}
                    onChange={(e) =>
                      setNewProduct((prev) => ({
                        ...prev,
                        status: e.target.value,
                      }))
                    }
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <button
                  type="button"
                  onClick={addProduct}
                  style={{ maxWidth: "fit-content" }}
                >
                  Make It Live
                </button>
              </div>
            </form>
          </div>
        </>
      )}
    </div>
  );
}

export default Products;
